"use client";

// "Demo viva" flotante sobre el hero-viz — 3 estados que ciclan cada 1900ms
// (`CV recibido` → `IA analizando…` → `Match 91 · Recomendada`), igual que
// `setLiveDemo()`/`.pm-demo` del handoff. El tweak `liveDemo` está ON por
// default.

import { useEffect, useState } from "react";
import { L } from "./tokens";

export function LiveDemoCard() {
  const [step, setStep] = useState<1 | 2 | 3>(1);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const id = setInterval(() => setStep((s) => ((s % 3) + 1) as 1 | 2 | 3), 1900);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      className="tl-float absolute hidden rounded-[14px] bg-white sm:block"
      style={{
        left: -46, top: "54%", width: 238, zIndex: 4,
        border: "1px solid rgba(21,16,61,.08)",
        boxShadow: "0 18px 40px -12px rgba(21,16,61,.25)",
        padding: "13px 14px", fontSize: 12.5,
        animationDelay: "0.7s",
      }}
    >
      {step === 1 && (
        <div className="flex items-center gap-2.5">
          <div className="flex h-[30px] w-[30px] flex-shrink-0 items-center justify-center rounded-lg text-sm" style={{ background: "#EFEDFF", color: "#6B5CFF" }}>📄</div>
          <div>
            <b className="block" style={{ fontSize: 12.5, color: L.ink }}>CV recibido</b>
            <small style={{ color: "#77748c", fontSize: 11 }}>maria-lopez.pdf · Portal</small>
          </div>
        </div>
      )}
      {step === 2 && (
        <div className="flex items-center gap-2.5">
          <div className="flex h-[30px] w-[30px] flex-shrink-0 items-center justify-center rounded-lg text-sm" style={{ background: L.ink, color: L.lime }}>✦</div>
          <div>
            <b className="flex items-center" style={{ fontSize: 12.5, color: L.ink }}>
              IA analizando
              <span className="ml-0.5 inline-flex gap-[3px]">
                {[0, 1, 2].map((i) => (
                  <i key={i} className="tl-dot h-1 w-1 rounded-full" style={{ background: "#6B5CFF", animationDelay: `${i * 0.15}s` }} />
                ))}
              </span>
            </b>
            <small style={{ color: "#77748c", fontSize: 11 }}>skills · experiencia · idiomas</small>
          </div>
        </div>
      )}
      {step === 3 && (
        <div className="flex items-center gap-2.5">
          <div className="flex h-[30px] w-[30px] flex-shrink-0 items-center justify-center rounded-lg text-sm" style={{ background: "#E9F9EE", color: "#1C9E55" }}>✓</div>
          <div style={{ flex: 1 }}>
            <b className="block" style={{ fontSize: 12.5, color: L.ink }}>Match 91 · Recomendada</b>
            <small style={{ color: "#77748c", fontSize: 11 }}>lista para entrevistar</small>
            <div className="mt-[7px] h-[5px] overflow-hidden rounded-full" style={{ background: "#EFEDFF" }}>
              <i key="fill" className="tl-bar-fill block h-full rounded-full" style={{ width: 0, background: "linear-gradient(90deg,#6B5CFF,#8F84FF)" }} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
